module.exports = __webpack_public_path__ + "static/media/london-25.bf2f0aeb.svg";